import { useState } from "react";
import { useGetPaymentApprovalSummaryQuery } from "../../lib/apiSlice/property/propertySlice.tsx";
import ApprovalsTable from "./_approvallists";
import MetricCard from "./_metricscards";
import { Helmet } from "react-helmet";
import PaymentHistory from "./_paymenthistory.jsx";

export default function PaymentApprovals() {
    const { data, isLoading, error } = useGetPaymentApprovalSummaryQuery();
    const [activeTab, setActiveTab] = useState("approvals");

    return (
        <div className="space-y-6">
            <Helmet>
                <title>Recorded Payments</title>
                <meta name="description" content="Payments approval records" />
            </Helmet>


            {/* Tabs */}
            <div>

                {/* Tab Content */}
                <div className="mt-4">
                    {activeTab === "approvals" && (
                        <>
                            <MetricCard
                                Total={data?.approved_approvals}
                                Pending={data?.pending_approvals}
                                Approved={data?.total_approvals}
                                Rejected={data?.rejected_approvals}
                            />
                            <ApprovalsTable
                                approvalData={data?.approval_details}
                                isloading={isLoading}
                            />
                        </>
                    )}
                    {activeTab === "payments" && (
                        <div>

                            <PaymentHistory
                                approvalData={data?.payment_histories}
                                isloading={isLoading}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
